import "./components/vlb";
import "./components/class-forms";
import { initHeader } from "./components/header";

document.addEventListener('DOMContentLoaded', function() {
  // Initialize header component
  initHeader();
});
